import React from 'react'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'
import { fetchBillform } from 'ducks/billform'
import { columns } from './data'
import { BillformDetailPath, billFormCreatePath, EditBillFormPath } from 'routes'
import { MainBodyContent, CustomButton, SearchList, TablePagination } from 'components'
import { ProcurementContainer, ProcurementBody } from '../styled'

const Billform = (props) => {
  const { listBillings, loading, valueForm } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    let searchCompanyCode = localStorage.getItem('searchCompanyCode')
    if(searchCompanyCode=='undefined') searchCompanyCode='[]'
    var comCode = JSON.parse(searchCompanyCode)
    let c = ''
    if (comCode && Array.isArray(comCode)) {
      comCode.forEach(i => {
        c += ',' + i
      })
      c = c.substring(1)
    } else {
      c = comCode
    }
    props.fetchBillform({ companyCode: c, page: 1, size: pageSize })
  }, [])

  return (
    <MainBodyContent headerTitle='Billing'
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(billFormCreatePath)}
            icon='plus'
            btnColor='gray'
            title='Create'
          />
        </div>
      }>
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            pageSize={pageSize} 
            placeholder='Doc No., Title, Requester' 
            fetchAPI={props.fetchBillform} 
            formSearchName='formSearchBilling' 
            filterDate 
            filterStatus 
            filterCompany 
            multiCompany 
            filterStatusOptions={[
              { key: 1,value: '-', text: 'All Status' },
              { key: 2,value: '0', text: 'Draft' },
              { key: 3,value: '1', text: 'New' },
              { key: 4,value: '2', text: 'In Progress' },
              { key: 7,value: '27', text: 'Wait for Original Doc.' },
              { key: 8,value: '28', text: 'Accepted' },
              { key: 5,value: '3', text: 'Revise' },
              { key: 6,value: '4', text: 'Completed' },
              { key: 7,value: '5', text: 'Reject' },
              { key: 8,value: '6', text: 'Cancelled' },
            ]}
          />
          <ReactTable
            columns={columns}
            data={Object.keys(listBillings).length > 0 ? listBillings.data : []}
            loading={loading}
            defaultPageSize={userPageSize}
            noDataText='No billing data'
            previousText={<Icon name='arrow alternate circle left' />}
            nextText={<Icon name='arrow alternate circle right' />}
            className='billFormList'
            PaginationComponent={TablePagination}
            pages={Object.keys(listBillings).length > 0 ? listBillings.totalPage : 0}
            currentPage={Object.keys(listBillings).length > 0 ? listBillings.page : 0}
            onPageChange={(pageIndex) => {
              let c = ''
              if (valueForm.companyCode && Array.isArray(valueForm.companyCode)) {
                valueForm.companyCode.forEach(i => {
                  c += ',' + i
                })
                c = c.substring(1)
              } else {
                c = valueForm.companyCode
              }
              props.fetchBillform({ ...valueForm, companyCode: c, page: pageIndex + 1, size: pageSize })
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              setPageSize(pageSize)
              localStorage.setItem('userPageSize', pageSize)
              let c = ''
              if (valueForm.companyCode && Array.isArray(valueForm.companyCode)) {
                valueForm.companyCode.forEach(i => {
                  c += ',' + i
                })
                c = c.substring(1)
              } else {
                c = valueForm.companyCode
              }
              props.fetchBillform({ ...valueForm, companyCode: c, page: pageIndex + 1, size: pageSize })
            }}

            getTdProps={(state, rowInfo, column) => {
              return {
                onClick: (e, handleOriginal) => {
                  if (rowInfo && column && column.Header !== '') {
                    if ([0, 1, 3].indexOf(rowInfo.original.status) >= 0) {
                      window.open(EditBillFormPath(rowInfo.original.id))
                    } else {
                      window.open(BillformDetailPath(rowInfo.original.id))
                    }
                  }
                  if (handleOriginal) {
                    handleOriginal()
                  }
                },
              }
            }}
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}
const mapStateToProps = (state) => ({
  listBillings: state.billform.listBillforms.data,
  loading: state.billform.listBillforms.loading,
  valueForm: getFormValues('formSearchBilling')(state)
})

const mapDispatchToProps = {
  fetchBillform
}

const contForm = reduxForm({
  form: 'formSearchBilling',
  enableReinitialize: true,
})(Billform)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)